import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromAuth from './auth/auth.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './auth/auth.effects';
import * as fromDebug from './debug/debug.reducer';
import { DebugEffects } from './debug/debug.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromAuth.authFeatureKey, fromAuth.authReducer),
    EffectsModule.forFeature([AuthEffects, DebugEffects]),
    StoreModule.forFeature(fromDebug.debugFeatureKey, fromDebug.debugReducer),
  ],
})
export class CommonStoreModule {}
